import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text, Toggle } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const ToggleInfoBox = (_param)=> {
    var { toggleId , icon , text , accessibleLabelText , className , checked , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "toggleId",
        "icon",
        "text",
        "accessibleLabelText",
        "className",
        "checked",
        "onChange"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('toggle-info-box', className)
    }), /*#__PURE__*/ React.createElement(Icon, {
        className: "toggle-info-box__icon",
        name: icon
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "span",
        "aria-hidden": true,
        className: "toggle-info-box__text"
    }, text), /*#__PURE__*/ React.createElement("label", {
        className: "toggle-info-box__label",
        htmlFor: toggleId
    }, accessibleLabelText && /*#__PURE__*/ React.createElement("span", {
        className: "toggle-info-box__accessibleLabel--visually-hidden"
    }, accessibleLabelText), /*#__PURE__*/ React.createElement(Toggle, {
        className: "toggle-info-box__toggle",
        id: toggleId,
        checked: checked,
        onChange: onChange
    })));
};
var ToggleInfoBox$1 = ToggleInfoBox;

export { ToggleInfoBox$1 as default };
//# sourceMappingURL=ToggleInfoBox.js.map
